import React from "react";
import "./Requirements.css";
import { Trans, useTranslation } from "react-i18next";
const GlsRequirements = () => {
  const { t } = useTranslation("settings");
  return (
    <div className="cuscarrier__reqrmnts_box">
      <Trans
        t={t}
        i18nKey="carriers.custom.requirements.gls"
        components={{
          mail: (
            <a href={`mailto:tech.support@dicomexpress.com`} className="email_space">
              tech.support@dicomexpress.com
            </a>
          ),
        }}
      />
    </div>
  );
};

export default GlsRequirements;
